import React from 'react';
import '../less/transfers.less';
import hero_img from '../img/ria/hero_img.png';
import attention_icon from '../img/wu/attention_icon.svg';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import { ReactSVG } from 'react-svg';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import polandGreeceLitvenia from '../../../../../../API/transfers/ria/poland.json';
import closeCountries from '../../../../../../API/transfers/ria/georgia.json';
import chinaHongKongOAE from '../../../../../../API/transfers/ria/hong_kong.json';
import farCountries from '../../../../../../API/transfers/ria/far.json';
import turkish from '../../../../../../API/transfers/ria/turkish.json';
import otherCountries from '../../../../../../API/transfers/ria/abroad.json';
import CustomDropdownNew from '../../../../../auxiliary-components/shared/CustomDropdownNew';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import { chooseRiaServicePoint, transfersAttentionUrl } from '../../../../../services/urls/urls';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'ria';

    const hero_data = {
      title: 'RIA_TITLE',
      text: 'RIA_DESC_1',
      link: {
        text: "RIA_BANNER_BTN_TEXT",
        onClick: () => window.open(chooseRiaServicePoint, "_blank"),
      }
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="ria-new">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
          page={page}
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <InfoBlock
                title={`RIA_NEW_INFO_TITLE_01`}
                text={`RIA_NEW_INFO_TEXT_01`}
              />
              <div className="ria-new__tariffs tariffs-ria-new">
                <TitleBlock title={'RIA_NEW_TARIFFS_TITLE'}/>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_1")} page={page} id={'tariffs-poland'}>
                  <div>
                    <TransferTableNew data={polandGreeceLitvenia}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_2")} page={page} id={'tariffs-close-countries'}>
                  <div>
                    <TransferTableNew data={closeCountries}/>
                  </div>
                  <div className="tariffs-ria-new__disclaimer">
                    <div className="container">
                      {this.l10n("RIA_TARIFFS_STAR_TEXT_1")}
                    </div>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_3")} page={page} id={'tariffs-china-hongkong-oae'}>
                  <div>
                    <TransferTableNew data={chinaHongKongOAE}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_4")} page={page} id={'tariffs-far-countries'}>
                  <div>
                    <TransferTableNew data={farCountries}/>
                  </div>
                  <div className="tariffs-ria-new__disclaimer">
                    <div className="container">
                      {this.l10n("RIA_TARIFFS_STAR_TEXT_2")}
                    </div>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_5")} page={page} id={'tariffs-turkish'}>
                  <div>
                    <TransferTableNew data={turkish}/>
                  </div>
                </CustomDropdownNew>
                <CustomDropdownNew title={this.l10n("RIA_TARIFFS_COUNTRY_TITLE_6")} page={page} id={'tariffs-other-countries'}>
                  <div>
                    <TransferTableNew data={otherCountries}/>
                  </div>
                </CustomDropdownNew>
              </div>
              <div className="ria-new__info-block">
                <InfoBlock
                  text={'RIA_NEW_INFO_TEXT_02'}
                />
                <InfoBlock
                  text={'RIA_NEW_INFO_TEXT_03'}
                />
                <div className="attention-block">
                  <div className="container">
                    <div className="attention-block__body">
                      <div className="attention-block__title">
                        <ReactSVG src={attention_icon} className="attention-block__icon"/>
                        {this.l10n('RIA_NEW_ATTENTION_BLOCK_TITLE')}
                      </div>
                      <div className="attention-block__text">
                        <ul>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_1')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_2')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_3')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_4')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_5')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_6')}</li>
                          <li>{this.l10n('RIA_HINT_LIST_ITEM_7')}</li>
                          <li>
                            {this.l10n('RIA_HINT_LIST_ITEM_8_1')}
                            <a href={transfersAttentionUrl} target='_blank' rel='noopener noreferrer'>{this.l10n('RIA_HINT_LIST_ITEM_8_2')}</a>
                          </li>
                        </ul>
                        <p>
                          {this.l10n('RIA_NEW_ATTENTION_BLOCK_TEXT_01')}
                          <a href="/about/general" target='_self' onClick={(e) => this.navigate("/about/general", e)}>{this.l10n('RIA_NEW_ATTENTION_BLOCK_LINK_01')}</a>
                        </p>
                        <p>
                          {this.l10n('RIA_NEW_ATTENTION_BLOCK_TEXT_02')}
                          <a href="/forpartners" target='_self' onClick={(e) => this.navigate("/forpartners", e)}>{this.l10n('RIA_NEW_ATTENTION_BLOCK_LINK_02')}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'FAQ_SHORT_NEW_TITLE'}
                page={page}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('YELLOW_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}